'use client';

import React from 'react';
import Link from 'next/link';
import { Zap, RefreshCw } from 'lucide-react';

export default function DashboardHeader() {
  return (
    <div className="flex items-start justify-between mb-6">
      <div>
        <p className="section-label mb-1">Übersicht</p>
        <h1 className="text-2xl font-800 text-white tracking-tight">Content Dashboard</h1>
        <p className="text-sm text-muted mt-1">
          Aktuelle Session · <span className="mono text-accent">03.04.2026</span> · Projekt: <span className="text-white font-500">Q2-Kampagne Berger GmbH</span>
        </p>
      </div>
      <div className="flex items-center gap-3">
        <button className="btn-ghost text-xs gap-2">
          <RefreshCw size={13} />
          Aktualisieren
        </button>
        <Link href="/content-generator" className="btn-primary">
          <Zap size={14} />
          Lärm filtern
        </Link>
      </div>
    </div>
  );
}